module.exports = __webpack_public_path__ + "img/icon_2_27.ac3f2b14.png";